import { merge } from 'lodash';
import brickxTheme from 'src/themes/brickx/brickxTheme';
import * as colors from 'src/themes/brickxAgri/colors';

const theme = merge({}, brickxTheme, {
  colors,
});

export default theme;
